import { getXid } from '@/features/auth/client';
import { centralizedLogin } from '@/sdk/client/centralizedLogin';

interface SignInOptions {
  isMvpd?: boolean;
  isEmployee?: boolean;
}

export async function signIn(options: SignInOptions = {}): Promise<void> {
  const { isMvpd = false, isEmployee = false } = options;

  try {
    const deviceId = await getXid();

    if (typeof window !== 'undefined') {
      window.sessionStorage.setItem('redirectUri', JSON.stringify(window.location.pathname + window.location.search));
    }

    const centralizedLoginParams = {
      isMvpd,
      deviceId,
      redirect: false,
    };

    await centralizedLogin.login({
      ...centralizedLoginParams,
      ...(isEmployee ? { isEmployee } : {}),
    });
  } catch (ex) {
    console.error('[CentralizedLogin][signIn] Error during sign-in:', ex);
  }
}
